
export class ClrResponsiveNavCodes {
public static NAV_LEVEL_1: number = 1;
public static NAV_LEVEL_2: number = 2;
public static NAV_CLOSE_ALL: string = "NAV_CLOSE_ALL";
public static NAV_OPEN: string = "NAV_OPEN";
public static NAV_CLOSE: string = "NAV_CLOSE";
public static NAV_TOGGLE: string = "NAV_TOGGLE";
public static NAV_CLASS_HAMBURGER_MENU: string = "open-hamburger-menu";
public static NAV_CLASS_OVERFLOW_MENU: string = "open-overflow-menu";
public static NAV_CLASS_TRIGGER_1: string = "header-hamburger-trigger";
public static NAV_CLASS_TRIGGER_2: string = "header-overflow-trigger";
public static NAV_CLASS_LEVEL_1: string = "clr-nav-level-1";
public static NAV_CLASS_LEVEL_2: string = "clr-nav-level-2";
}

function ClrResponsiveNavCodes_tsickle_Closure_declarations() {
/** @type {?} */
ClrResponsiveNavCodes.NAV_LEVEL_1;
/** @type {?} */
ClrResponsiveNavCodes.NAV_LEVEL_2;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLOSE_ALL;
/** @type {?} */
ClrResponsiveNavCodes.NAV_OPEN;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLOSE;
/** @type {?} */
ClrResponsiveNavCodes.NAV_TOGGLE;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_HAMBURGER_MENU;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_OVERFLOW_MENU;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_TRIGGER_1;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_TRIGGER_2;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_LEVEL_1;
/** @type {?} */
ClrResponsiveNavCodes.NAV_CLASS_LEVEL_2;
}

